import React, { useContext, useState } from 'react';
import { ChildrenWithProps, SetStateAction } from '../types/globals';

import type { User } from '../types/user';
import { Service } from '../types/user/service';
import { PALETTE_FEATURE } from '../services/constants/globals';

interface AuthContextType {
  user: User;
  setUser: (user: User) => void;
  services: Service[];
  setServices: SetStateAction<Service[]>;
  manabiteService: Service;
  tokiteService: Service;
}

export const AuthContext = React.createContext<AuthContextType>({
  user: {},
  setUser: () => {},
  services: [],
  setServices: () => {},
  manabiteService: { id: 0 },
  tokiteService: { id: 0 },
});

const AuthProvider = ({ children }: ChildrenWithProps) => {
  const [user, setUser] = useState<User>({});
  const [services, setServices] = useState<Service[]>([]);
  const manabiteService = services?.find((service) => service.id === PALETTE_FEATURE.MANABITE.ID) || {
    id: 0,
  };
  const tokiteService = services?.find((service) => service.id === PALETTE_FEATURE.TOKITE.ID) || {
    id: 0,
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, services, setServices, manabiteService, tokiteService }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuthContext = () => useContext(AuthContext);
